export default __webpack_public_path__ + "static/media/Note_3_img.a1038fc3.jpg";